import { render, staticRenderFns } from "./IframeViewer.vue?vue&type=template&id=55a2ccef&scoped=true"
import script from "./IframeViewer.vue?vue&type=script&lang=js"
export * from "./IframeViewer.vue?vue&type=script&lang=js"
import style0 from "./IframeViewer.vue?vue&type=style&index=0&id=55a2ccef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a2ccef",
  null
  
)

export default component.exports